import React from 'react';
import Loadable from 'react-loadable'

function Loading() {
  
  return (
    <div><div className={"text-center"} colSpan="8"><i className="fa fa-refresh fa-spin fa-3x fa-fw"></i>
    <span className="sr-only">Loading...</span></div></div>

  )
  
};

// Lazy load DefaultLayout to avoid circular dependency
const DefaultLayout = Loadable({
  loader: () => import('./containers/DefaultLayout'),
  loading: Loading,
});

const Breadcrumbs = Loadable({
  loader: () => import('./views/Base/Breadcrumbs'),
  loading: Loading,
});

const Cards = Loadable({
  loader: () => import('./views/Base/Cards'),
  loading: Loading,
});

const Carousels = Loadable({
  loader: () => import('./views/Base/Carousels'),
  loading: Loading,
});

const Collapses = Loadable({
  loader: () => import('./views/Base/Collapses'),
  loading: Loading,
});

const Dropdowns = Loadable({
  loader: () => import('./views/Base/Dropdowns'),
  loading: Loading,
});

const Forms = Loadable({
  loader: () => import('./views/Base/Forms'),
  loading: Loading,
});

const Jumbotrons = Loadable({
  loader: () => import('./views/Base/Jumbotrons'),
  loading: Loading,
});

const ListGroups = Loadable({
  loader: () => import('./views/Base/ListGroups'),
  loading: Loading,
});

const Navbars = Loadable({
  loader: () => import('./views/Base/Navbars'),
  loading: Loading,
});

const Navs = Loadable({
  loader: () => import('./views/Base/Navs'),
  loading: Loading,
});

const Paginations = Loadable({
  loader: () => import('./views/Base/Paginations'),
  loading: Loading,
});

const Popovers = Loadable({
  loader: () => import('./views/Base/Popovers'),
  loading: Loading,
});

const ProgressBar = Loadable({
  loader: () => import('./views/Base/ProgressBar'),
  loading: Loading,
});

const Switches = Loadable({
  loader: () => import('./views/Base/Switches'),
  loading: Loading,
});

const Tables = Loadable({
  loader: () => import('./views/Base/Tables'),
  loading: Loading,
});

const Tabs = Loadable({
  loader: () => import('./views/Base/Tabs'),
  loading: Loading,
});

const Tooltips = Loadable({
  loader: () => import('./views/Base/Tooltips'),
  loading: Loading,
});

const BrandButtons = Loadable({
  loader: () => import('./views/Buttons/BrandButtons'),
  loading: Loading,
});

const ButtonDropdowns = Loadable({
  loader: () => import('./views/Buttons/ButtonDropdowns'),
  loading: Loading,
});

const ButtonGroups = Loadable({
  loader: () => import('./views/Buttons/ButtonGroups'),
  loading: Loading,
});

const Buttons = Loadable({
  loader: () => import('./views/Buttons/Buttons'),
  loading: Loading,
});

const Charts = Loadable({
  loader: () => import('./views/Charts'),
  loading: Loading,
});

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const CoreUIIcons = Loadable({
  loader: () => import('./views/Icons/CoreUIIcons'),
  loading: Loading,
});

const Flags = Loadable({
  loader: () => import('./views/Icons/Flags'),
  loading: Loading,
});

const FontAwesome = Loadable({
  loader: () => import('./views/Icons/FontAwesome'),
  loading: Loading,
});

const SimpleLineIcons = Loadable({
  loader: () => import('./views/Icons/SimpleLineIcons'),
  loading: Loading,
});

const Alerts = Loadable({
  loader: () => import('./views/Notifications/Alerts'),
  loading: Loading,
});

const Badges = Loadable({
  loader: () => import('./views/Notifications/Badges'),
  loading: Loading,
});

const Modals = Loadable({
  loader: () => import('./views/Notifications/Modals'),
  loading: Loading,
});

const Colors = Loadable({
  loader: () => import('./views/Theme/Colors'),
  loading: Loading,
});

const Typography = Loadable({
  loader: () => import('./views/Theme/Typography'),
  loading: Loading,
});

const Widgets = Loadable({
  loader: () => import('./views/Widgets/Widgets'),
  loading: Loading,
});

const Users = Loadable({
  loader: () => import('./views/Users/Users'),
  loading: Loading,
});

const UserData = Loadable({
  loader: () => import('./views/Users/UserData'),
  loading: Loading,
});

const UserAdd = Loadable({
  loader: () => import('./views/Users/UserAdd'),
  loading: Loading,
});

const Contests = Loadable({
  loader: () => import('./views/Contests/Contests'),
  loading: Loading,
});

const ContestSchedule = Loadable({
  loader: () => import('./views/Contests/ContestSchedule'),
  loading: Loading,
});



const ContestData = Loadable({
  loader: () => import('./views/Contests/ContestData'),
  loading: Loading,
});

const ContestScheduleData = Loadable({
  loader: () => import('./views/Contests/ContestScheduleData'),
  loading: Loading,
});


const ContestBreakup = Loadable({
  loader: () => import('./views/Contests/ContestBreakup'),
  loading: Loading,
});

const ContestDetails = Loadable({
  loader: () => import('./views/Contests/ContestUserDetails'),
  loading: Loading,
});
const ContestScheduleDetails = Loadable({
  loader: () => import('./views/Contests/ContestScheduleDetails'),
  loading: Loading,
});

const AdminProfile = Loadable({
  loader: () => import('./views/Admin/Profile'),
  loading: Loading,
});

const AdminEdit = Loadable({
  loader: () => import('./views/Admin/ProfileEdit'),
  loading: Loading,
});

const ForgotPassword = Loadable({
  loader: () => import('./views/Pages/Login/ForgotPassword'),
  loading: Loading,
});

const ResetPassword = Loadable({
  loader: () => import('./views/Pages/Login/ResetPassword'),
  loading: Loading,
});

// const Slider = Loadable({
//   loader: () => import('./views/Slider/Slider'),
//   loading: Loading,
// });

const Points = Loadable({
  loader: () => import('./views/Points/Points'),
  loading: Loading,
});




const ContestCategory = Loadable({
  loader: () => import('./views/Contests/ContestCategory/ContestCategory'),
  loading: Loading,
});

const ContestCategoryAdd = Loadable({
  loader: () => import('./views/Contests/ContestCategory/ContestCategoryAdd'),
  loading: Loading,
});

const ContestCategoryData = Loadable({
  loader: () => import('./views/Contests/ContestCategory/ContestCategoryData'),
  loading: Loading,
});


const UserWithdraw = Loadable({
  loader: () => import('./views/UserWithdraw/UserWithdraw'),
  loading: Loading,
});

const UserWithdrawData = Loadable({
  loader: () => import('./views/UserWithdraw/UserWithdrawData'),
  loading: Loading,
});

const PlayerManager = Loadable({
  loader: () => import('./views/PlayerManager/PlayerManager'),
  loading: Loading,
});



// const ReferralBonus = Loadable({
//   loader: () => import('./views/ReferralBonus/ReferralBonus'),
//   loading: Loading,
// });

const Templates = Loadable({
  loader: () => import('./views/Template/EmailTemplate.js'),
  loading: Loading,
});

const TemplatesView = Loadable({
  loader: () => import('./views/Template/EmailTemplateView.js'),
  loading: Loading,
});

const TemplatesEdit = Loadable({
  loader: () => import('./views/Template/EmailTemplateEdit.js'),
  loading: Loading,
});

const wallets = Loadable({
  loader: () => import('./views/Wallets/Wallets.js'),
  loading: Loading,
});


// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const subAdminRoutes = [
  { path: '/', exact: true, name: 'Home', component: DefaultLayout },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/theme', exact: true, name: 'Theme', component: Colors },
  { path: '/theme/colors', name: 'Colors', component: Colors },
  { path: '/theme/typography', name: 'Typography', component: Typography },
  { path: '/base', exact: true, name: 'Base', component: Cards },
  { path: '/base/cards', name: 'Cards', component: Cards },
  { path: '/base/forms', name: 'Forms', component: Forms },
  { path: '/base/switches', name: 'Switches', component: Switches },
  { path: '/base/tables', name: 'Tables', component: Tables },
  { path: '/base/tabs', name: 'Tabs', component: Tabs },
  { path: '/base/breadcrumbs', name: 'Breadcrumbs', component: Breadcrumbs },
  { path: '/base/carousels', name: 'Carousel', component: Carousels },
  { path: '/base/collapses', name: 'Collapse', component: Collapses },
  { path: '/base/dropdowns', name: 'Dropdowns', component: Dropdowns },
  { path: '/base/jumbotrons', name: 'Jumbotrons', component: Jumbotrons },
  { path: '/base/list-groups', name: 'List Groups', component: ListGroups },
  { path: '/base/navbars', name: 'Navbars', component: Navbars },
  { path: '/base/navs', name: 'Navs', component: Navs },
  { path: '/base/paginations', name: 'Paginations', component: Paginations },
  { path: '/base/popovers', name: 'Popovers', component: Popovers },
  { path: '/base/progress-bar', name: 'Progress Bar', component: ProgressBar },
  { path: '/base/tooltips', name: 'Tooltips', component: Tooltips },
  { path: '/buttons', exact: true, name: 'Buttons', component: Buttons },
  { path: '/buttons/buttons', name: 'Buttons', component: Buttons },
  { path: '/buttons/button-dropdowns', name: 'Button Dropdowns', component: ButtonDropdowns },
  { path: '/buttons/button-groups', name: 'Button Groups', component: ButtonGroups },
  { path: '/buttons/brand-buttons', name: 'Brand Buttons', component: BrandButtons },
  { path: '/icons', exact: true, name: 'Icons', component: CoreUIIcons },
  { path: '/icons/coreui-icons', name: 'CoreUI Icons', component: CoreUIIcons },
  { path: '/icons/flags', name: 'Flags', component: Flags },
  { path: '/icons/font-awesome', name: 'Font Awesome', component: FontAwesome },
  { path: '/icons/simple-line-icons', name: 'Simple Line Icons', component: SimpleLineIcons },
  { path: '/notifications', exact: true, name: 'Notifications', component: Alerts },
  { path: '/notifications/alerts', name: 'Alerts', component: Alerts },
  { path: '/notifications/badges', name: 'Badges', component: Badges },
  { path: '/notifications/modals', name: 'Modals', component: Modals },
  { path: '/widgets', name: 'Widgets', component: Widgets },
  { path: '/charts', name: 'Charts', component: Charts },
  { path: '/contests', exact: true,  name: 'Contests', component: Contests },
  { path: '/contests/add', exact: true,  name: 'Add Contest', component: ContestData },
  { path: '/contests/edit', exact: true,  name: 'Edit Contest', component: ContestData },
  { path: '/contests/schedule/:id', exact: true,  name: 'Add Contest Schedule', component: ContestScheduleData },
  { path: '/contests/get', exact: true,  name: 'Contest Details', component: ContestDetails },
  { path: '/contests/breakup/:id', exact: true,  name: 'Update Contests Breakup', component: ContestBreakup },

  { path: '/contests/detail/:id', exact: true,  name: 'Contest Details', component: ContestDetails },

  { path: '/contests_schedule/', exact: true,  name: 'Contests', component: ContestSchedule },
  { path: '/contests_schedule/add', exact: true,  name: 'Add Contest', component: ContestSchedule },
  { path: '/contests_schedule/edit', exact: true,  name: 'Edit Contest', component: ContestSchedule },
  { path: '/contests_schedule/get/:id', exact: true,  name: 'Contest Details', component: ContestScheduleDetails },
  

  { path: '/contestcategory', exact: true, name: 'Contest Categories', component: ContestCategory },
  { path: '/contestcategory/add', exact: true, name: 'Add Contest Category', component: ContestCategoryAdd },
  { path: '/contestcategory/edit/:id', exact: true, name: 'Edit Contest Category', component: ContestCategoryAdd },
  { path: '/contestcategory/get/:id', exact: true, name: 'Contest Category Details', component: ContestCategoryData },

  { path: '/users', exact: true,  name: 'Users', component: Users },
  { path: '/users/add', exact: true, name: 'Add User', component: UserAdd },
  { path: '/users/get/:id', exact: true, name: 'Get User Details', component: UserData },
  { path: '/users/edit/:id', exact: true, name: 'Edit User Details', component: UserAdd },
  { path: '/admin', exact: true, name: 'Admin', component: AdminProfile },
  { path: '/admin/edit/:id', exact: true, name: 'Edit Admin Profile', component: AdminEdit },
  { path: '/password/forgot', exact: true, name: 'Enter Email', component: ForgotPassword },
  { path: '/password/reset', exact: true, name: 'Enter Password', component: ResetPassword },
  // { path: '/slider', exact: true, name: 'Slider Images', component: Slider },
  { path: '/points', exact: true, name: 'Points Details', component: Points },
  { path: '/userwithdraw', exact: true, name: 'User Withdraw Request', component: UserWithdraw },
  { path: '/userwithdraw/:id', exact: true, name: 'View Withdraw Request', component: UserWithdrawData },
  { path: '/playermanager', exact: true, name: 'Manage Player Credits', component: PlayerManager },
  // { path: '/referralbonus', exact: true, name: 'Referral Bonus', component: ReferralBonus },
  { path: '/templates', exact: true, name: 'Email Templates', component: Templates },
  { path: '/templates/get/:id', exact: true, name: 'Email Template Details', component: TemplatesView },
  { path: '/templates/edit/:id', exact: true, name: 'Edit Email Template', component: TemplatesEdit },
  { path: '/wallet/list', exact: true, name: 'User Wallets', component: wallets },
  
  
  
];

export default subAdminRoutes;
